import type { PartyStatusId } from '@steerfi/shared';
import type React from 'react';
import { getStatusColor, getStatusLabel } from '@/components/status-chip';
import { Badge } from '@/components/ui/badge';

interface PartnerStatusBadgeProps {
  statusId: number;
}

/**
 * Status chip for a party/partner status id. Uses the shared party-status color
 * and label helpers so Active/Inactive/Suspended all render consistently with
 * the rest of the app (the reference-admin StatusChip only knows active/inactive).
 */
export const PartnerStatusBadge: React.FC<PartnerStatusBadgeProps> = ({ statusId }) => {
  const variant = getStatusColor(statusId as PartyStatusId, 'party');
  const label = getStatusLabel(statusId as PartyStatusId, 'party');
  return (
    <Badge
      variant="outline"
      className={`text-xs font-medium ${
        variant === 'default'
          ? 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800'
          : variant === 'destructive'
            ? 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800'
            : variant === 'secondary'
              ? 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800'
              : ''
      }`}
    >
      {label}
    </Badge>
  );
};
